import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=ed343ae6&scoped=true&"
import script from "./ContentBlock.vue?vue&type=script&lang=js&"
export * from "./ContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&id=ed343ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed343ae6",
  null
  
)

export default component.exports